'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const BASE_URL = 'https://accounts.shopify.com/store-create';
const SELECTORS = {
  LOGIN_FORM: 'signup[email]',
  ZERO_FIELD_SELECTOR: '.js-open-signup',
  ONE_FIELD_SELECTOR: '.js-signup-inline .start-free-trial__button',
  THREE_FIELD_SELECTOR: '.signup-form .marketing-form__button',
  INLINE_FORM_SELECTOR: 'form.js-signup-inline',
  HIDDEN_FORM_SELECTOR: '.signup--hidden .signup-form'
};
const COOKIE_NAMES = {
  SOURCE: 'source',
  SESSION_TOKEN: '_shopify_s'
};
const URL_PARAMS = {
  SESSION_TOKEN: '_s',
  MICRO_SESSION_ID: '_p',
  MULTITRACK_TOKEN: '_y',
  LOGIN: 'login',
  SIGNUP_TYPES: 'signup_types[]',
  SIGNUP_PAGE: 'signup_page',
  SIGNUP_REF: 'ref',
  PROMO_CODE: 'promotional_program_code_promo_code',
  GEO_COUNTRY_CODE: 'geo_country_code',
  AFFILIATE: 'affiliate',
  AFFILIATE_IR_CLICK_ID: 'irclickid',
  AFFILIATE_IRGWC: 'irgwc',
  AFFILIATE_PARTNER_ID: 'partner',
  AFFILIATE_PARTNER_EXCLUDED: 'affpt'
};
const AFFILIATE_TRACKING_PARAMS = [URL_PARAMS.AFFILIATE_IR_CLICK_ID, URL_PARAMS.AFFILIATE_IRGWC, URL_PARAMS.AFFILIATE_PARTNER_ID, URL_PARAMS.AFFILIATE_PARTNER_EXCLUDED];
const SIGNUP_REF_AND_PROMO_PARAMS = [URL_PARAMS.SIGNUP_REF, URL_PARAMS.PROMO_CODE];

exports.AFFILIATE_TRACKING_PARAMS = AFFILIATE_TRACKING_PARAMS;
exports.BASE_URL = BASE_URL;
exports.COOKIE_NAMES = COOKIE_NAMES;
exports.SELECTORS = SELECTORS;
exports.SIGNUP_REF_AND_PROMO_PARAMS = SIGNUP_REF_AND_PROMO_PARAMS;
exports.URL_PARAMS = URL_PARAMS;
